import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ca-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
})
export class ModalContainerComponent implements OnInit {
    @Input() modalTitle = '';
    @Input() description = '';
    @Input() showClose = true;
    @Input() showTitle = true;
    @Input() showDescription = true;
    @Input() isTitleCentered = false;
    @Input() hasFullwidthButton = false;
    @Input() isBodyCentered = false;

    @Output() dismiss = new EventEmitter<string>();

    isScrollingTimeout: NodeJS.Timeout;
    wasAlreadyClicked = false;

    ngOnInit(): void {
        // Problem: In a modal the ng-select appended to the body will stay in position when the modal window gets scrolled
        // Solution: Close the ng-select on scroll and reopen it when the scrolling has stopped
        // set scroll event listener to ngb-modal-window (there is only one) because it gets the scroll event of the modal
        // the event listener will be removed on destroy of the ngb-modal-window tag
        document.getElementsByTagName('ngb-modal-window')[0]?.addEventListener('scroll', (): void => {
            // this is the element to interact with to open and close the ng-select
            const selectContainers: NodeListOf<Element> = document.querySelectorAll('.ng-select-container');

            // go through all ng-select containers and pick the open one
            selectContainers.forEach((selectContainer: Element): void => {
                if (this.isNgSelectOpen(selectContainer)) {
                    // only click once when the scrolling starts to close the ng-select
                    if (!this.wasAlreadyClicked) {
                        this.dispatchMouseDownEvent(selectContainer);
                        this.wasAlreadyClicked = true;
                    }

                    // clear timeout and set new timeout as long as the user is scrolling
                    window.clearTimeout(this.isScrollingTimeout);
                    this.isScrollingTimeout = setTimeout(
                        (element, that): void => {
                            // click again when scrolling has stopped
                            that.dispatchMouseDownEvent(element);

                            // reset
                            that.wasAlreadyClicked = false;
                        },
                        // after 100 milliseconds the timeout fires and the ng-select will be opened again
                        100,
                        selectContainer,
                        this,
                    );
                }
            });
        });
    }

    private isNgSelectOpen(selectContainer: Element): boolean {
        return !!selectContainer.parentElement?.classList.contains('ng-select-opened');
    }

    private dispatchMouseDownEvent(element: Element): void {
        const clickEventMousedown = document.createEvent('MouseEvents');
        clickEventMousedown.initEvent('mousedown', true, true);
        element.dispatchEvent(clickEventMousedown);
    }
}
